export const toPersianNumbers = (
  num: string | number | null | undefined,
): string => {
  if (num === null || num === undefined) return "";
  const farsiDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  return num.toString().replace(/\d/g, (x) => farsiDigits[parseInt(x, 10)]);
};

export const toEnglishNumbers = (
  num: string | number | null | undefined,
): string => {
  if (num === null || num === undefined) return "";
  const persianDigits = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
  ];
  const arabicDigits = [
    /٠/g,
    /١/g,
    /٢/g,
    /٣/g,
    /٤/g,
    /٥/g,
    /٦/g,
    /٧/g,
    /٨/g,
    /٩/g,
  ];
  let str = num.toString();
  for (let i = 0; i < 10; i++) {
    str = str
      .replace(persianDigits[i], i.toString())
      .replace(arabicDigits[i], i.toString());
  }
  return str;
};

export const formatCurrency = (
  num: string | number | null | undefined,
): string => {
  if (num === null || num === undefined) return "";
  const parsed = typeof num === "string" ? parseFloat(num) : num;
  if (isNaN(parsed)) return toPersianNumbers(num);
  return toPersianNumbers(parsed.toLocaleString()) + " ریال";
};

export const formatJalaliDate = (
  dateStr: string | null | undefined,
): string => {
  if (!dateStr) return "-";
  if (
    typeof dateStr === "string" &&
    dateStr.includes("-") &&
    (dateStr.startsWith("19") || dateStr.startsWith("20"))
  ) {
    try {
      const date = new Date(dateStr);
      if (!isNaN(date.getTime())) {
        return new Intl.DateTimeFormat("fa-IR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }).format(date);
      }
    } catch (e) {
      // ignore
    }
  }
  return toPersianNumbers(dateStr);
};
